export const URL="https://generativelanguage.googleapis.com/v1beta/models/gemini-flash-latest:generateContent?key=AIzaSyBrKEz1k64rs9aGvUPrAuwh7v9ibG04mHM"